import { Alert, Card } from "react-bootstrap";
import { useContext, useState } from "react";
import { NavigationContext } from "../../../Context/NavigationContext";
import DealCodeModal from "../DealCodeModal";
import { importDealCode } from "../../../dr/Components/drFuncs";
import { useAppSelector } from "../../../redux/hooks";

const NewHomeInFile = () => {
    const livedataRoot = useAppSelector((state) => state.currentNavigation.livedataRootContainer?.dataRoot);
    const [showDealCodeModal, setShowDealCodeModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const nav = useContext(NavigationContext);

    const handleDealCodeSubmit = (dealCode: string) => {
        importDealCode(dealCode, "infile", livedataRoot?.getAttribute("AppID"), nav).then(() => {
            setShowDealCodeModal(false);
            setErrorMessage(null);
        }).catch((error) => {
            console.error("Error importing deal code:", error);
            setErrorMessage(error.message);
        });
    };
    
    return (
        
        <div>
            <Card>
            <Card.Header>
            <h2>NewHome</h2>
            </Card.Header>
            <Card.Body>
            <Alert variant="info" className="d-flex justify-content-between align-items-center mb-3">
                <p className="mb-0">Connect a NewHome Deal from your inbox.</p>
            </Alert>
            <Card.Text>
                <div style={{fontWeight: "bold", display: "inline"}}>Can't find your deal?</div> Try importing from a deal code <u><a onClick={() => setShowDealCodeModal(true)}>here</a></u>.
            </Card.Text>
            </Card.Body>
        </Card>
            <DealCodeModal
                show={showDealCodeModal}
                onClose={() => setShowDealCodeModal(false)}
                onSubmit={handleDealCodeSubmit}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
            />
        </div>
        
    );
};

export default NewHomeInFile;
